<div
  *ngFor="let index of steps"
  fxFlex="36px"
  [ngStyle]="{ height: '4px' }"
  [ngClass]="{
    'bg-color-black': currentStep === index,
    'bg-color-grey-100': currentStep !== index,
  }"
></div>
